import { useNavigate } from 'react-router-dom';
import { IErrRes } from 'type/db';
import { removeCookie } from 'utils/cookies';
import useToast from './useToast';

const useAuthOver = (): [(err: IErrRes) => boolean, () => void] => {
	const toast = useToast();
	const navigate = useNavigate();

	const authOverCondition = (err: IErrRes) =>
		err.resultCode === 'authentication_failed' || err.resultCode === 'token_not_valid';

	const setAuthOverError = () => {
		toast('로그인 기간이 만료되었습니다.', false, true);
		removeCookie('imms_access_token', { path: '/' });
		removeCookie('imms_workspace_code', { path: '/' });
		navigate('/imms/login', { replace: true });
	};

	return [authOverCondition, setAuthOverError];
};

export default useAuthOver;
